<template>
    <div class="offerInfo">
        <div class="title ben-border-t">
            <span class="ben-000-color ben-size-15 ben-text-bold">基本资料</span>
        </div>
        <div class="info-list">
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">报价主题</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <div class="title-right-comm">
                        我对您发布的"{{data.wantBuyAndDetails.title}}"很感兴趣
                    </div>
                </van-col>
            </van-row>
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">交货期</span>
                </van-col>
                <van-col span="14" class="ben-000-color ben-size-14 title-right"> 
                    <van-field v-model="deliveryDays" placeholder="请输入可交货到指定地点天数" type="digit" @input="changeInput" maxlength="3"/>
                </van-col>
                <van-col span="2" class="ben-333-color ben-size-14 ben-align-right"> 
                    天
                </van-col>
            </van-row>
            <van-row class="info-list-comm ben-border-t">
                <van-col span="8" class="title-left">
                    <span class="ben-333-color ben-size-14">补充说明</span>
                </van-col>
                <van-col span="16" class="ben-000-color ben-size-14 title-right"> 
                    <van-field v-model="explainText" :autosize=autosize type="textarea" maxlength="200"  @input="changeTextarea"
                        placeholder="(非必填项) 可以写优势，如价格优惠、阶梯价格、优 惠品牌、资质等提升竞价优势,150字内" />
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
export default {
    name:'offerInfo',
    props : {
        data : {
            type : Object
        }
    },
    data () {
        return {
            deliveryDays : "",
            explainText : '',
            inputData : {
                
            },
            autosize : {
                 maxHeight: 100, minHeight: 50
            },
            dataObj : {
                added : "",//补充说明
                delivery_date : "",//交货期限
            }
        }
    },
    methods: {
        changeInput(events){
            if(events==0){
                this.deliveryDays = ""
                return false
            }
            this.dataObj.delivery_date = events;
            this.$emit("setOfferTopInfo",this.dataObj)
        },
        changeTextarea(e){
            this.dataObj.added = e;
            this.$emit("setOfferTopInfo",this.dataObj)
        }
    },
    mounted () {
        
    },
}

</script>


<style lang='scss' scoped>
.offerInfo{
    margin-top: 8px;
    background: #fff;
    .van-cell{
        padding: 0;
    }
    .info-list-comm{
        margin:0 15px ;
        padding: 15px 0;
    }
    .title{
        padding: 20px 15px 10px 15px;
        >span{
            border-bottom: 3px solid #C41335;
            padding-bottom: 10px;

        }
    }
}
    
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerInfo.vue